<template>
  <el-form ref="formRef" :model="state.formData" :rules="rules" class="form-wrapper" @keyup.enter="onSubmit">
    <el-form-item prop="account">
      <el-input class="ipt-common" v-model="state.formData.account" disabled
        :placeholder="$t('form.emailTips')"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input class="ipt-common" type="password" show-password v-model="state.formData.password"
        :placeholder="$t('form.password')"></el-input>
    </el-form-item>
    <el-form-item prop="confirmPassword">
      <el-input class="ipt-common" type="password" :placeholder="$t('form.confirmPass')"
        v-model="state.formData.confirmPassword" show-password />
    </el-form-item>
    <el-button class="submit-button" @click="onSubmit" :loading="state.isLoading">
      {{ $t('form.button.submit') }}
    </el-button>
  </el-form>
</template>

<script setup>
import { resetPassword } from '@/apis/user';
import { encryptPwd } from '@/utils/encrypt';
import reg from '@/utils/reg';
import { ElMessage } from 'element-plus';
import { Base64 } from 'js-base64';
import { onMounted, reactive, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
const { t } = useI18n();
const formRef = ref();
const $router = useRouter();
const $route = useRoute();
const state = reactive({
  isLoading: false,
  uuid: undefined,
  formData: {
    account: undefined,
    code: undefined,
    password: undefined,
    confirmPassword: ''
  },
  rules: {
    account: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty')
      },
      {
        pattern: reg.mailReg,
        trigger: 'blur',
        message: t('pecenter.forget.inputBindEmail')
      }
    ],
    password: [
      {
        required: true,
        trigger: 'blur',
        message: t('pecenter.forget.inputPwd')
      },
      {
        pattern: reg.passwordReg,
        trigger: 'blur',
        message: t('form.verifyPass')
      }
    ],
    confirmPassword: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty')
      },
      {
        pattern: reg.passwordReg,
        trigger: 'blur',
        message: t('form.verifyPass')
      }
    ]
  }
});
const { account, uuid } = $route.query;
if (account) {
  if (!account.includes('@')) {
    state.formData.account = Base64.decode(account);
  } else {
    state.formData.account = account;
  }
  state.uuid = uuid;
}
const { rules } = toRefs(state);

// 提交回调
const onSubmit = async () => {
  if (state.isLoading) return;
  state.isLoading = true;
  formRef.value.validate(async valid => {
    if (valid) {
      try {
        const params = {
          account: state.formData.account,
          uuid: state.uuid,
          password: await encryptPwd(state.formData.password)
        };
        await resetPassword(params);
        ElMessage({ message: t('common.editSuccess'), type: 'success' });
        $router.push('/login');
      } catch (error) {
        ElMessage({ message: error, type: 'error' });
      } finally {
        state.isLoading = false;
      }
    } else {
      state.isLoading = false;
    }
  });
};
onMounted(() => {
  const { account, uuid } = $route.query;
  if (account) {
    if (!account.includes('@')) {
      state.formData.account = Base64.decode(account);
    } else {
      state.formData.account = account;
    }
    state.uuid = uuid;
  }
});
</script>

<style lang="scss" scoped>
.form-wrapper {
  width: 400px;
  margin-top: 68px;

  .ipt-common {
    width: 400px;
    height: 44px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  ::v-deep {
    .el-input {
      .el-input__inner {
        &::placeholder {
          font-family: Montserrat;
          font-size: 14px;
          color: #8492b2;
        }
      }

      .el-input__wrapper {
        height: 44px;
      }
    }
  }

  .submit-button {
    cursor: pointer;
    width: 400px;
    height: 56px;
    border-radius: 8px;
    text-align: center;
    line-height: 56px;
    background-color: var(--primary-color);
    color: var(--white-color-1);
    margin-top: 24px;
  }
}
</style>
